var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import api from './api'; // Importa a instância configurada
import { getHeader } from './header'; // Importa o gerador de cabeçalhos
// Função para buscar o nome da agência
export var getAgencyName = function () { return __awaiter(void 0, void 0, Promise, function () {
    var header, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.get('/users/agency-name', header)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
// Função para buscar os dados do usuário logado
export var getUserData = function () { return __awaiter(void 0, void 0, Promise, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [2 /*return*/, api.get('/users/me', header)];
        }
    });
}); };
// Função para atualizar a preferência de tutorial visto
export var setTutorialSeen = function () { return __awaiter(void 0, void 0, Promise, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.patch('/users/me/', { tutorial_seen: true }, header)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
// Função para atualizar dados do usuário
export var updateUserData = function (data) { return __awaiter(void 0, void 0, Promise, function () {
    var header, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.patch('/users/me', data, header)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.data];
        }
    });
}); };
// Função para excluir o próprio usuário (perfil)
export var deleteUserAccount = function () { return __awaiter(void 0, void 0, Promise, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.delete('/users/me', header)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
// ✅ Buscar preferências de notificação
export var getNotificationPreferences = function () { return __awaiter(void 0, void 0, Promise, function () {
    var header, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.get('/users/notification-preferences', header)];
            case 2:
                response = _a.sent();
                return [2 /*return*/, response.data.preferences];
        }
    });
}); };
// ✅ Atualizar preferências de notificação
export var updateNotificationPreferences = function (preferences) { return __awaiter(void 0, void 0, Promise, function () {
    var header;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                return [4 /*yield*/, api.post('/users/notification-preferences', { preferences: preferences }, header)];
            case 2:
                _a.sent();
                return [2 /*return*/];
        }
    });
}); };
// ✅ NOVO: Enviar mensagem de teste para WhatsApp
export var sendTestWhatsAppNotification = function () { return __awaiter(void 0, void 0, Promise, function () {
    var header, response, error_1, errorData;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, getHeader()];
            case 1:
                header = _a.sent();
                _a.label = 2;
            case 2:
                _a.trys.push([2, 4, , 5]);
                return [4 /*yield*/, api.post('/notifications/test', {}, // Body vazio (não precisa enviar dados)
                    header)];
            case 3:
                response = _a.sent();
                return [2 /*return*/, response.data];
            case 4:
                error_1 = _a.sent();
                // ✅ Captura erros do backend e retorna mensagem amigável
                if (error_1.response && error_1.response.data) {
                    errorData = error_1.response.data;
                    // ✅ Se o backend retornar 'error' e 'hint'
                    if (errorData.error) {
                        throw new Error(errorData.hint
                            ? "".concat(errorData.error, " ").concat(errorData.hint)
                            : errorData.error);
                    }
                    // ✅ Se tiver 'details' (erro técnico)
                    if (errorData.details) {
                        throw new Error("Erro ao enviar: ".concat(errorData.details));
                    }
                }
                // ✅ Erro genérico
                throw new Error('Não foi possível enviar a mensagem de teste. Verifique sua conexão.');
            case 5: return [2 /*return*/];
        }
    });
}); };
